/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    INVENTORY_PAGE_SPLIT_COMPONENTS_UPLOAD_MODALS
 * Date:         2025-12-30
 * Modified By:  Cursor
 *
 * Description:
 * Extracted Upload confirmation modal from InventoryPage.tsx.
 */

import React from "react";
import { Modal, Button } from "react-bootstrap";

interface InventoryUploadModalsProps {
  showUploadConfirm: boolean;
  onHide: () => void;
  onConfirm: () => void;
  isUploading: boolean;
}

const InventoryUploadModals: React.FC<InventoryUploadModalsProps> = ({
  showUploadConfirm,
  onHide,
  onConfirm,
  isUploading,
}) => {
  return (
    <Modal show={showUploadConfirm} onHide={onHide} centered className="erb-modal">
      <Modal.Header closeButton>
        <Modal.Title>Confirm Upload</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-0">
          Uploading will overwrite existing data in your inventory. Continue?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onConfirm} disabled={isUploading}>
          {isUploading ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Uploading...
            </>
          ) : (
            "Yes, Upload"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InventoryUploadModals;
